import { useEffect, useState } from "react";
import { Box, Button, TextField, IconButton, Tab, Tabs } from "@mui/material";
import { ReactComponent as ArrowbackIcon } from "../../Assets/arrowback.svg";
import Grid from "@mui/material/Grid2";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  createMeterValue,
  editMeterValue,
  getMeterValueData,
} from "../../Services/ExperienceApi";

function PageMeterValue() {
  const [tabValue, setTabValue] = useState("expired");
  const [equalsValue, setEqualsValue] = useState("");
  const [startingValue, setStartingValue] = useState("");
  const [everyValue, setEveryValue] = useState("");
  const [title, setTitle] = useState("Meter Value");
  const [titleError, setTitleError] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const fullMeterValueId = location.state?.data?.id || "";
  const meterValueId = fullMeterValueId;
  const sessionData = sessionStorage.getItem("pendingNodeAddition");
  const sessionObj = sessionData ? JSON.parse(sessionData) : {};
  const meterId = location.state?.meterId;
  const experienceId = location.state?.experienceId || sessionObj.experinceId;
  const fullSegmentId =
    location.state?.segmentId || sessionObj.segmentId.split("_")[1];
  const segmentId = location.state?.segmentId
    ? fullSegmentId.split("_")[1]
    : fullSegmentId;

  useEffect(() => {
    const fetchExperience = async () => {
      if (meterValueId) {
        const response = await getMeterValueData(meterValueId);
        if (response.success === true && response) {
          const MeterData = response.meter_value;
          setTitle(MeterData.title);
          if (MeterData.is_expired_condition) {
            setTabValue("expired");
          } else if (MeterData.is_equals_condition) {
            setTabValue("equals");
            setEqualsValue(MeterData.equals_value?.toString() || ""); // ensure it's a string for input
          } else if (MeterData.is_increments_condition) {
            setTabValue("increments");
            setStartingValue(
              MeterData.increments_starting_value?.toString() || ""
            );
            setEveryValue(MeterData.increments_every_value?.toString() || "");
          }
        }
      }
    };
    fetchExperience();
  }, [meterValueId]);
  const handleSave = async () => {
    const payload = {
      title: title,
      is_expired_condition: tabValue === "expired",
      is_equals_condition: tabValue === "equals",
      ...(tabValue === "equals" && {
        equals_value: parseInt(equalsValue),
        equals_unit: "pageviews",
      }),
    };
    let response;
    try {
      setLoading(true);
      if (meterValueId) {
        response = await editMeterValue(meterValueId, payload);
      } else {
        response = await createMeterValue(
          experienceId,
          segmentId,
          meterId,
          payload
        );
      }
      if (response.success === true) {
        toast.success(response.message);
        navigate(-1);
      } else {
        toast.error(response.error);
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };
  const onback = () => {
    navigate(-1);
  };
  return (
    <div className="templates">
      {/* Header Section */}
      <Grid container className="templates__header">
        <Grid
          size={{ xs: 12, md: 3, sm: 6 }}
          className="templates__header--search"
        >
          <div className="d-center">
            <span className="Icon">
              <IconButton aria-label="close" onClick={onback}>
                <ArrowbackIcon />
              </IconButton>{" "}
            </span>{" "}
            <h2> Meter value</h2>
          </div>
        </Grid>

        <Grid
          size={{ xs: 12, md: 9, sm: 6 }}
          className="templates__header--button "
        >
          <Box className="button-heading">
            <Button
              className="button"
              sx={{
                "--variant-containedBg": "rgba(228, 0, 43, 1)",
                "&:hover": {
                  "--variant-containedBg": "rgba(228, 0, 43, 1)",
                  "--variant-textBg": "rgba(228, 0, 43, 0.04)",
                },
              }}
              variant="contained"
              color="error"
              onClick={handleSave}
              disabled={loading}
            >
              {loading ? <span className="loader" /> : "Save"}
            </Button>
            <Button
              sx={{
                "--variant-outlinedBorder": "rgba(228, 0, 43, 1)",
                "--variant-outlinedColor": "rgba(228, 0, 43, 1)",
                "--variant-containedBg": "rgba(228, 0, 43, 1)",

                "&:hover": {
                  "--variant-outlinedBorder": "rgba(228, 0, 43, 1)",
                  "--variant-outlinedBg": "rgba(228, 0, 43, 0.04)",
                  "--variant-containedBg": "rgba(228, 0, 43, 1)",
                  "--variant-textBg": "rgba(228, 0, 43, 0.04)",
                },
              }}
              variant="outlined"
              onClick={onback}
            >
              Cancel
            </Button>
          </Box>
        </Grid>
      </Grid>

      <Box className="editSegment__container" mt={2}>
        <Grid container alignItems={"center"}>
          <Grid size={{ xs: 12, md: 2, sm: 3 }}>
            <div className="editSegment__container--heading">
              <h2>TITLE OF CARD :</h2>
            </div>
          </Grid>
          <Grid
            size={{ xs: 12, md: 8, sm: 9 }}
            className="editSegment__container--heading"
          >
            <TextField
              variant="standard"
              fullWidth
              required
              value={title}
              error={titleError}
              helperText={titleError ? "Title is required" : ""}
              onChange={(e) => {
                const value = e.target.value;
                setTitle(value);
                if (value.trim()) {
                  setTitleError(false);
                }
              }}
            />
          </Grid>
        </Grid>
      </Box>
      <Box className="editSegment__container">
        <Grid container spacing={{ xs: 0, sm: 2, md: 2 }} alignItems={"center"}>
          <Grid size={{ xs: 12, md: 2, sm: 6 }}>
            <div className="editSegment__container--heading br-1">
              <h2> PROPERTIES</h2>
            </div>
          </Grid>
          <Grid size={{ xs: 12, md: 10, sm: 6 }}>
            <div className="editSegment__container--tab">
              <Tabs
                value={tabValue}
                onChange={(e, newValue) => setTabValue(newValue)}
                indicatorColor="primary"
              >
                <Tab label="Expired" value="expired" />
                <Tab label="Equals" value="equals" />
              </Tabs>
            </div>
          </Grid>
        </Grid>
        <Box className="editSegment__container" m={1}>
          {tabValue === "equals" && (
            <div className="editSegment__container--innerheading bb-1">
              <h2>Equals</h2>
              <div className="pageview">
                <TextField
                  variant="standard"
                  fullWidth
                  value={equalsValue}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (/^\d*$/.test(val)) setEqualsValue(val);
                  }}
                  inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                />
                <p>pageviews</p>
              </div>
            </div>
          )}

          {tabValue === "expired" && (
            <div className="editSegment__container--innerheading bb-1">
              <h2>
                <b>Meter has expired.</b>
              </h2>
            </div>
          )}

          {tabValue === "increments" && (
            <>
              <div className="editSegment__container--innerheading bb-1">
                <h2>Starting At</h2>
                <div className="pageview">
                  <TextField
                    variant="standard"
                    fullWidth
                    value={startingValue}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (/^\d*$/.test(val)) setStartingValue(val);
                    }}
                    inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                  />
                  <p>pageviews</p>
                </div>
              </div>
              <div className="editSegment__container--innerheading bb-1">
                <h2>Every</h2>
                <div className="pageview">
                  <TextField
                    variant="standard"
                    fullWidth
                    value={everyValue}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (/^\d*$/.test(val)) setEveryValue(val);
                    }}
                    inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                  />
                  <p>pageviews</p>
                </div>
              </div>
            </>
          )}
        </Box>
      </Box>
    </div>
  );
}

export default PageMeterValue;
